import { gql } from '@apollo/client';
import {
  SchemaFieldsFragment,
  CreatorFields,
  EditorFields,
} from '../fragments';
import { FilterFragment } from '../filters';
import { FieldFieldsFragment } from '../fields';
import { EntityCategoryFragment } from '../entityCategories';
import { BasicEventValueFragment } from '../basicEvents/fragments';
import {
  AnyEventFieldsFragment,
  AnyTableEventFieldsFragment,
} from '../events/any';

export const VirtualEventFragment = gql`
  fragment VirtualEventFields on VirtualEvent {
    kind
    comment
    description
    id
    name
    version
    isLatestVersion
    createdAt
    updatedAt
    isDisabled
    creator {
      ...CreatorFields
    }
    editor {
      ...EditorFields
    }
    editedAt
    schema {
      ...SchemaFields
    }
    eventsConditions {
      field {
        ...FieldFields
      }
      events {
        ... on AnyEvent {
          ...AnyEventFields
        }
        ... on BasicEventValue {
          ...BasicEventValueFields
        }
        ... on AnyTableEvent {
          ...AnyTableEventFields
        }
      }
      filter {
        ...FilterFields
      }
    }
    categories {
      ...EntityCategoryFields
    }
    isFavorite
    isManaged
  }
  ${SchemaFieldsFragment}
  ${CreatorFields}
  ${EditorFields}
  ${FieldFieldsFragment}
  ${FilterFragment}
  ${EntityCategoryFragment}
  ${AnyEventFieldsFragment}
  ${AnyTableEventFieldsFragment}
  ${BasicEventValueFragment}
`;
